import image1 from '../../assets/programs/engagement_with_parliamentaries/image_1.webp'
import image2 from '../../assets/programs/engagement_with_parliamentaries/image_2.webp'

const grip_data = {
    "title": "Engagement with Parliamentarians",
    "description": "The event focuses on discussing key technological advancements and policy recommendations with Indian parliamentarians. The proposed topics include AI in Healthcare, which explores AI-driven medical advancements and patient care; Green Technology & Sustainable Environment, which promotes eco-friendly innovations; Quantum Technology & Cybersecurity, emphasizing the role of quantum technology in enhancing security; and Building India's Semiconductor Ecosystem, aimed at strengthening India's self-reliance in semiconductor manufacturing. The session is set to take place at the Parliament Annexe during the winter session, providing a platform for dialogue between academia and policymakers on critical technological frontiers shaping India's future.",
    "content": [
        {
            "primaryHeading": "",
            "subContent": [
                {
                    "secondaryHeading": "",
                    "description": "Timeline : December 2023",
                    "images": [
                        {
                            "src": image1,
                            "desc": ""
                        },
                        {
                            "src": image2,
                            "desc": ""
                        }
                    ]
                }
            ]
        }
    ]
}

export default grip_data;